import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Environment banner — visible in development and test only.
 * Source of truth is the backend `/api/system/environment` endpoint so the
 * banner cannot be spoofed by the frontend build alone.
 */
export default function EnvBanner() {
  const [env, setEnv] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/system/environment")
      .then(({ data }) => alive && setEnv(data?.environment || null))
      .catch(() => alive && setEnv(null));
    return () => {
      alive = false;
    };
  }, []);

  if (!env || env === "production") return null;

  const label =
    env === "test"
      ? "TEST ENVIRONMENT — NOT FOR PRODUCTION USE"
      : "DEVELOPMENT ENVIRONMENT — NOT FOR PRODUCTION USE";

  const bg = env === "test" ? "bg-amber-500" : "bg-orange-500";

  return (
    <div
      data-testid="env-banner"
      className={`${bg} text-white text-xs font-semibold text-center py-1.5 tracking-wide`}
    >
      {label}
    </div>
  );
}
